import { jobLists } from "character";
import Link from "components/link/Link";
import NoCharacter from "components/no-character/NoCharacter";
import { quests } from "data-files/quests";
import { shops } from "data-files/shops";
import { EorzeaDataType, GameData, LinkType, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import ContentHeader from "views/page-parts/content/content-header/ContentHeader";
import DetailsSection from "views/page-parts/content/details-section/DetailsSection";
import OverviewTable from "views/page-parts/content/overview-table/OverviewTable";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewToolSplendorousSplendorousProps } from "views/relics/tools/splendorous/splendorous/types";
import "./ToolSplendorousSplendorous.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showJob: state.userInfo.options.job,
	};
};

class ToolSplendorousSplendorous extends Component<ViewToolSplendorousSplendorousProps> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.TOOL_SPLENDOROUS],
		type: RelicData.Type.TOOL,
		relic: RelicData.Group.TOOL_SPLENDOROUS,
		part: RelicData.Part.TOOL_SPLENDOROUS,
		steps: [RelicData.Step.SPLENDOROUS_PURCHASE],
		stepPlaceholders: {},
		next: {
			part: RelicData.Part.TOOL_AUGMENTED_SPLENDOROUS,
			view: View.RELIC_TOOLS_SPLENDOROUS_AUGMENTED_SPLENDOROUS,
		},
		previous: null,
	};

	constructor(props:ViewToolSplendorousSplendorousProps){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		const completeSteps = manager.content.getCompleteSteps(character.progress, this.relicInfo);

		return (
			<div id="tool-splendorous-splendorous" className="relic">
				<ContentHeader requirements={this.requirements} importantNPCs={this.importantNPCs} relicInfo={this.relicInfo}>
					<p>{t.t("Complete")}<Link
						type={LinkType.LODESTONE}
						lodestoneType={EorzeaDataType.BLUEQUEST}
						text={GameData.Quest.ORIGINAL_IMPROVEMENT}
						lodestoneID={quests[GameData.Quest.ORIGINAL_IMPROVEMENT].lodestoneID}
					/></p>
				</ContentHeader>
				<div id="relic-checklist">
					<OverviewTable character={character} completeSteps={completeSteps} relicInfo={this.relicInfo} />
				</div>
				<div id="relic-details">
					<h1>{t.t("Details")}</h1>
					{this.props.hideCompletedSteps && completeSteps.allComplete ? t.t("All Steps Complete") : null }
					<DetailsSection title={RelicData.Step.SPLENDOROUS_PURCHASE} id={RelicData.Step.SPLENDOROUS_PURCHASE} stepComplete={completeSteps[RelicData.Step.SPLENDOROUS_PURCHASE]}>
						<p>
							{t.t("After completing %QUEST% - The rest of the base tools can be purchased from %SHOP% for 1,500 %CURRENCY1% or %CURRENCY2% each (12,00 %CURRENCY1% and 4,500 %CURRENCY2% in total)", {
								QUEST: GameData.Quest.ORIGINAL_IMPROVEMENT,
								SHOP: GameData.Shop.QUINNANA,
								CURRENCY1: GameData.Currency.SCRIP_COMMON_CRAFTER,
								CURRENCY2: GameData.Currency.SCRIP_COMMON_GATHERER,
							})}
						</p>
						<p><Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.SHOP} lodestoneID={shops[GameData.Shop.QUINNANA].lodestoneID} text={GameData.Shop.QUINNANA} /></p>
					</DetailsSection>
				</div>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		return [
			{ type: quests[GameData.Quest.ENDWALKER].type, text: GameData.Quest.ENDWALKER, lodestoneID: quests[GameData.Quest.ENDWALKER].lodestoneID },
			{ type: quests[GameData.Quest.CRYSTALLINE_MEAN].type, text: GameData.Quest.CRYSTALLINE_MEAN, lodestoneID: quests[GameData.Quest.CRYSTALLINE_MEAN].lodestoneID },
			{ type: "text", text: "Complete 'The Boutique Always Wins' from Mowen in Eulmore (x11, y11)" },
		];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [GameData.NPC.MOWEN, GameData.NPC.KATLISS, GameData.NPC.CHORA_ZOI];
	}
}
export default connect(mapStateToProps)(ToolSplendorousSplendorous);
